import { t } from '@hefe/i18n';
import { Club } from '@hefe/models';
import { Col, Descriptions, Row, Typography } from 'antd';
import { environment } from '../../../../../environments/environment';

interface ClubPressCenterSettingsComponentProps {
  club: Club;
}

export default function ClubPressCenterSettingsComponent(
  props: ClubPressCenterSettingsComponentProps
) {
  const { club } = props;

  const url = environment.landingUrl + '/press-center?clubId=' + club.uuid;

  return (
    <Row>
      <Col xs={24}>
        <Typography.Paragraph>
          {t('press_center.settings.feature_info')}
        </Typography.Paragraph>
      </Col>
      <Col xs={24}>
        <Descriptions bordered column={1}>
          <Descriptions.Item label={t('press_center.settings.link.title')}>
            <Typography.Link href={url} target="_blank">
              {url}
            </Typography.Link>
          </Descriptions.Item>
          <Descriptions.Item label={t('press_center.settings.iframe.title')}>
            <Typography.Paragraph code>
              {`<iframe src="${url}" title="${t(
                'press_center.title'
              )}" onload="this.width=window.innerWidth;this.height=window.innerHeight;" frameborder="0"></iframe>`}
            </Typography.Paragraph>
            <Typography.Paragraph>
              {t('press_center.settings.iframe.description')}
            </Typography.Paragraph>
          </Descriptions.Item>
        </Descriptions>
      </Col>
    </Row>
  );
}
